module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_train_color_black-65eb5fa5b6ea8a2a04c662cbfe846fd5.svg";